import { getLocalStorageItem, saveLocalStorageItem } from '@shared/utils/browserStorageUtils';
const smileFrownSubmittedTimeKey = 'lastFeedbackTime';
export const storeFeedbackSubmittedTime = ()=>{
    saveLocalStorageItem(smileFrownSubmittedTimeKey, JSON.stringify(new Date()));
};
export const getFeedbackSubmittedTime = ()=>{
    try {
        const lastSubmittedTime = JSON.parse(getLocalStorageItem(smileFrownSubmittedTimeKey));
        return Date.parse(lastSubmittedTime) ? new Date(lastSubmittedTime) : null;
    } catch (error) {
        return null;
    }
};
